import { render, staticRenderFns } from "./ListForumPage.vue?vue&type=template&id=e03a76c8"
import script from "./ListForumPage.vue?vue&type=script&lang=js"
export * from "./ListForumPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports